import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "flowbite";
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";

const Coupons = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");
    const [coupons, setCoupons] = useState([]);

    const navigate = useNavigate();

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    const [filters, setFilters] = useState({
        code: "",
        page: 1,
        limit: 10,
    });
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 0,
    });

    useEffect(() => {
        const getCoupons = async () => {

            try {
                const queryParams = Object.entries(filters)
                    .filter(([_, value]) => value) // Only include parameters with non-empty values
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join("&");
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/coupons/get-coupons?${queryParams}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                if (res.data.success) {
                    setCoupons(res.data.data.coupons);
                    setPagination({
                        totalRecords: res.data.data.pagination.totalRecords,
                        currentPage: res.data.data.pagination.currentPage,
                        totalPages: res.data.data.pagination.totalPages,
                        limit: res.data.data.pagination.limit,
                    });
                } else {
                    setCoupons([]);
                }


            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                    }
                } else {
                    // Handle other errors
                    toast.error("No Coupons Found!");
                }
            }
        }
        getCoupons();
        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'coupons'
            ));
        }

    }, [filters]);


    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
            page: 1, // Reset to the first page on filter change
        }));
    };

    const handlePageChange = (newPage) => {
        setFilters((prev) => ({ ...prev, page: newPage }));
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString.replace(" ", "T")); // Replace space with T for compatibility
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const time = date.toLocaleTimeString('en-US', { hour12: false });
        return `${formattedDate} ${time}`;
    };

    return (
        <div className="bg-gray-100">
            <div className="py-20 p-4 sm:ml-64">
                <div className="md:flex justify-between py-5">

                    {/* Filters UI */}
                    <div className=" items-center md:flex gap-4">
                        <input
                            type="text"
                            placeholder="Search by Coupon Code"
                            value={filters.code}
                            onChange={(e) => handleFilterChange("code", e.target.value)}
                            className="my-1 md:my-0 flex border-2 rounded-full px-3 py-2"
                        />

                    </div>
                </div>


                <div className="w-full  p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">

                    <div className="flex justify-start">
                        <div className="flex flex-col text-left">
                            <h1 className="text-xl text-black font-bold">Coupons</h1>

                        </div>

                    </div>

                    <div className="relative overflow-x-auto custom-scrollbar sm:rounded-lg mt-5">

                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Coupon Code</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Coupon Value</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Is Used</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Is Sold</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Generated By</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Customer Name</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Customer Email</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Date/Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coupons.length > 0 ? (
                                    permissionModule.canRead ? coupons.map((coupon) => (
                                        <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.code}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.value}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.isUsed ? "Yes" : "No"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.isSold ? "Yes" : "No"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.User ? coupon.User.name : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.customerName ? coupon.customerName : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{coupon.customerEmail ? coupon.customerEmail : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(coupon.updatedAt)}</td>


                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 whitespace-normal break-words">No Coupons Found.</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>


                        {/* Pagination */}
                        <div className="flex justify-center my-4">
                            <button
                                onClick={() => handlePageChange(filters.page - 1)}
                                disabled={filters.page === 1}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 mx-1 font-medium">
                                Page {pagination.currentPage} of {pagination.totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(filters.page + 1)}
                                disabled={filters.page === pagination.totalPages}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Coupons;